export default function (gerencia: number): any {
  const baseFilter = {
    or: [
      {
        responsavelNegocial: {
          perfisAcesso: {
            some: {
              perfil: {
                eq: gerencia,
              },
            },
          },
        },
      },
      {
        responsavelProcessual: {
          perfisAcesso: {
            some: {
              perfil: {
                eq: gerencia,
              },
            },
          },
        },
      },
    ],
  };

  // GRCP
  if (gerencia === 119) {
    return {
      ...baseFilter,
      ...{
        carteirasContratos: {
          some: {
            vigente: {
              eq: true,
            },
            carteira: {
              tipo: {
                neq: 4,
              },
            },
          },
        },
      },
    };
  }

  // GRV
  if (gerencia === 30) {
    return {
      ...baseFilter,
      ...{
        carteirasContratos: {
          some: {
            vigente: {
              eq: true,
            },
            carteira: {
              tipo: {
                eq: 4,
              },
            },
          },
        },
      },
    };
  }

  return baseFilter;
}
